export default "__VITE_ASSET__Dabsy26g__"